<app-contacts-add-person
  [returnRouteAbort]="'contacts/persons'"
  [returnRouteSubmit]="'contacts/persons'"
  (onAbort)="handleAbort($event)"
  (onSubmit)="handleSubmit($event)"
></app-contacts-add-person>
